import React from 'react';

interface ZipExtProps {
    width?: number;
    height?: number;
}

export const ZipExt = ({ height = 26, width = 26 }: ZipExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18361)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#E9CD18"
            />
            <path
                d="M13.2273 17.603H11.9182V16.9844H13.2273C13.4666 16.9844 13.6603 16.9468 13.8084 16.8716C13.9565 16.7941 14.0647 16.687 14.1331 16.5503C14.2014 16.4136 14.2356 16.2575 14.2356 16.082C14.2356 15.9202 14.2014 15.7676 14.1331 15.624C14.0647 15.4805 13.9565 15.3654 13.8084 15.2788C13.6603 15.1899 13.4666 15.1455 13.2273 15.1455H12.1336V19.5H11.3611V14.5234H13.2273C13.6079 14.5234 13.9303 14.5907 14.1946 14.7251C14.4612 14.8573 14.664 15.0407 14.803 15.2754C14.942 15.5101 15.0115 15.7767 15.0115 16.0752C15.0115 16.3965 14.942 16.6711 14.803 16.8989C14.664 17.1268 14.4612 17.3011 14.1946 17.4219C13.9303 17.5426 13.6079 17.603 13.2273 17.603Z"
                fill="white"
            />
            <path d="M10.52 14.5234V19.5H9.74756V14.5234H10.52Z" fill="white" />
            <path
                d="M9.18332 18.8813V19.5H5.76193V18.8813H9.18332ZM9.09103 15.0293L6.01144 19.5H5.509V18.9771L8.59201 14.5234H9.09103V15.0293ZM8.78683 14.5234V15.1455H5.53976V14.5234H8.78683Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18361">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
